// extracted by mini-css-extract-plugin
export default {"success":"cKjxp+N69vYVYYaTfKatkg==","successIcon":"OGUcSxUT9BlJ556aTnRUMA==","priceCta":"I-8Vmssf-MJm+duw9+8y4g=="};